(function () {
  var burger = document.querySelector("[data-hh-burger]");
  var nav = document.querySelector("[data-hh-nav]");
  if (burger && nav) {
    burger.addEventListener("click", function () {
      nav.classList.toggle("is-open");
      burger.classList.toggle("is-open");
    });
  }
  var searchToggle = document.querySelector("[data-hh-search-toggle]");
  var search = document.querySelector("[data-hh-search]");
  if (searchToggle && search) {
    searchToggle.addEventListener("click", function () {
      search.classList.toggle("is-open");
      var input = search.querySelector("input");
      if (input && search.classList.contains("is-open")) input.focus();
    });
  }

  var rotator = document.querySelector("[data-hh-ugc]");
  if (rotator) {
    var slides = rotator.querySelectorAll(".hh-ugc");
    var i = 0;
    if (slides.length > 1) {
      setInterval(function () {
        slides[i].classList.remove("is-active");
        i = (i + 1) % slides.length;
        slides[i].classList.add("is-active");
      }, 5000);
    }
  }

  var moreWrap = document.querySelector("[data-hh-more]");
  var moreBtn = document.querySelector("[data-hh-more-btn]");
  if (moreWrap && moreBtn) {
    moreBtn.addEventListener("click", function () {
      var open = moreWrap.classList.toggle("is-open");
      moreBtn.textContent = open ? "Less" : "More";
    });
  }
})();
